import { useMemo } from 'react';
import { ActivityFilterKey } from '../models/ActivityFilters';
import { DateFilterKey } from '../models/DateFilters';
import { FileFilterKey } from '../models/FileFilters';
import { LocationFilterKey } from '../models/LocationFilters';
export function useFilterNameMap(locResources) {
    return useMemo(function () {
        var filterNameMap = new Map([
            /**
             * Note: Please make sure to avoid removing or modifying a key if possible, because custom pivots use
             * them and they are persisted through Edgeworth Settings API.
             */
            [FileFilterKey.word, locResources.wordName],
            [FileFilterKey.excel, locResources.excelName],
            [FileFilterKey.powerpoint, locResources.powerPointName],
            [FileFilterKey.forms, locResources.formsName],
            [FileFilterKey.visio, locResources.visioName],
            [FileFilterKey.fluid, locResources.loopComponentName],
            [FileFilterKey.drafts, locResources.draftName],
            [FileFilterKey.onenote, locResources.oneNoteName],
            [FileFilterKey.meeting, locResources.meetingName],
            [FileFilterKey.sway, locResources.sway],
            [FileFilterKey.clipchamp, locResources.clipchampName],
            [FileFilterKey.powerbi, locResources.powerBiName],
            [FileFilterKey.pdf, locResources.pdfName],
            [FileFilterKey.link, locResources.linkName],
            [FileFilterKey.image, locResources.imageName],
            [FileFilterKey.video, locResources.videoName],
            [FileFilterKey.designer, locResources.designerName],
            [FileFilterKey.whiteboard, locResources.whiteboardName],
            [FileFilterKey.other, locResources.otherText],
            [ActivityFilterKey.created, locResources.createdText],
            [ActivityFilterKey.mentions, locResources.mentionsText],
            [ActivityFilterKey.edits, locResources.editsText],
            [ActivityFilterKey.comments, locResources.commentsText],
            [ActivityFilterKey.tasks, locResources.tasksText],
            [ActivityFilterKey.hidden, locResources.hiddenByMeText],
            [DateFilterKey.anytime, locResources.anytimeText],
            [DateFilterKey.yesterday, locResources.yesterdayText],
            [DateFilterKey.previousweek, locResources.previousWeekText],
            [DateFilterKey.previousmonth, locResources.previousMonthText],
            [LocationFilterKey.cloudFiles, locResources.cloudFilesPivotLabel],
            [LocationFilterKey.local, locResources.localFilesPivotLabel],
            [LocationFilterKey.attachments, locResources.attachmentsPivotLabel],
        ]);
        return filterNameMap;
    }, [locResources]);
}
//# sourceMappingURL=useFilterNameMap.js.map